import { get, has, set, unset } from 'lodash'

export default class MemoryCacheDriver {
  static cache = {}

  has (key) {
    return has(MemoryCacheDriver.cache, key)
  }

  async get (key) {
    return get(MemoryCacheDriver.cache, key)
  }

  async set (key, value) {
    set(MemoryCacheDriver.cache, key, value)
  }

  async reset () {
    MemoryCacheDriver.cache = []
  }

  async resetKey (key) {
    unset(MemoryCacheDriver.cache, key)
  }
}
